(function() {
  if (!('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      entry.target.classList.toggle('is-in-view', entry.isIntersecting);
    });
  }, { rootMargin: '50px 0px', threshold: 0 });
  ['.brand-marquee', '.hero-kinetic', '.hero-immersive', '.carousel-3d']
    .forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) { observer.observe(el); });
    });
})();
